import React,{useEffect, useState} from "react"

import { Row, Col, Card, CardBody, Badge, CardTitle, InputGroup, Label, FormGroup, Button, Modal, Pagination, PaginationItem, PaginationLink } from "reactstrap"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import Flatpickr from "react-flatpickr"
import Select from "react-select"
import { connect } from "react-redux";
import * as url from "../../helpers/url_helper"
import { setBreadcrumbItems } from "../../store/actions";
import { RingLoader } from "react-spinners";
import { BarLoader } from "react-spinners";
import { set } from "lodash"
import moment from "moment"
import { useNavigate } from "react-router-dom"


const Fiches = (props) => {
  document.title = "Fiches | Liste des fiches de livraison";
  const breadcrumbItems = [{ title: "Lexa", link: "#" }, { title: "Tables", link: "#" }, { title: "Responsive Table", link: "#" }, ]
  const [loadingFiche, setLoadingFiche] = useState(false);
  const [totalPage, setTotalPage] = useState(0);
  const [currPage, setCurrPage] = useState(0);
  const [agences, setAgences] = useState([]);
  const [selectedDest, setSelectedDest] = useState(null);
  const [fiches, setFiches] = useState([]);
  const [totalFiches, setTotalFiches] = useState(0);
  const [dest, setDest] = useState(null);
  const [modal_formfiche, setmodal_formfiche] = useState(false)
  const [msgError, setMsgError]= useState("");
  const [msgSuccess, setMsgSuccess]= useState("");
  const optionGroup = [ { options: agences } ]
  const handleDestination= (event)=>{ setSelectedDest(event); setDest(event.value); }
  const userJson= JSON.parse(localStorage.getItem("user"));
  const handleLivreur= (event)=>{ setSelectLivreur(event); setLivreur(event.value); }
  const [readOnly, setReadOnly]= useState(false)
  const [livreurs, setLivreurs] = useState([]);
  const [livreur, setLivreur] = useState(null);
  const optionLivreur = [ { options: livreurs } ]
  const [selectLivreur, setSelectLivreur] = useState(null);
  const navigate = useNavigate();
  const verifData= ()=>{
    if (livreur==="" || livreur==='undefined' || livreur==null) { setMsgError("Sélectionner un livreur"); return false;}
    else {return true; }
  }

  const loadAgences= ()=> {
    let userJson= JSON.parse(localStorage.getItem("user"));
    let agencesArray= [{label: "Toutes les agences", value: null}];
    fetch(url.BACKEND_URL+"/agence?etp="+userJson.usAgence.agEtp.etpId+"&size=100", {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => { 
      if (responseJson.status==200) { 
        agencesArray=[
          ...agencesArray,
          ...responseJson.data.map(item=>({
          label: item.agNom,
          value: item.agId
        }))];
        setAgences(agencesArray);
    } else {  }
    }) .catch((error) => {  });
  };

  const saveFiche=()=>{
    if (verifData()) {
      fetch(url.API_LIVRAISON_BACKEND+"/fiches", {
        method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify( { livreur: {id: livreur} }) })
      .then((response) => response.json())
      .then((responseJson) => { console.log(responseJson.data);
        if (responseJson.status==200) { 
          // loadFiches(0);
          setMsgSuccess(responseJson.message)
          navigate('/view-fiche', {state: {fiche: responseJson.data}});
      } else { setMsgError(responseJson.message);  }
      }) .catch((error) => { setMsgError(error.message); });
    }
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }
  function tog_formfiche() {
    setmodal_formfiche(!modal_formfiche)
    removeBodyCss()
  }

  const loadLivreurs=()=> {
    let livreurArray= [];
    fetch(url.API_LIVRAISON_BACKEND+"/livreurs?page=0&size=50", {
      method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => { 
      if (responseJson.status==200) { 
        livreurArray= [
          ...livreurArray,
          ...responseJson.data.items.map(item=>({
            label: item.nom+" ("+item.partenaire.etp.nom+")",
            value: item.id
          }))
        ]
        setLivreurs(livreurArray);
    } else { setLivreurs([]); }
    }) .catch((error) => { alert(error); });
  };

  const loadFiches=(page)=> {
    setLoadingFiche(true)
    fetch(url.API_LIVRAISON_BACKEND+"/fiches?page="+page+"&size=20", {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => { 
      if (responseJson.status==200) { 
        setFiches(responseJson.data.items)
        setTotalFiches(responseJson.data.total)
        setTotalPage(responseJson.data.total_pages, 30)
        setCurrPage(responseJson.data.page, 30)
        setLoadingFiche(false)
    } else { setFiches([]); setLoadingFiche(false) }
    }) .catch((error) => { setLoadingFiche(false) });
  };

  useEffect(() => {
    props.setBreadcrumbItems('Gestionaires', breadcrumbItems)
    loadAgences()
    loadFiches(0)
    loadLivreurs()
  }, [])

  return (
    <React.Fragment>
      <Modal
        size="xl"
        isOpen={modal_formfiche}
        toggle={() => { tog_formfiche() }}
        >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myLargeModalLabel">Formulaire de création de fiche de livraison</h5>
          <button
            onClick={() => {
              setmodal_formfiche(false)
            }}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true" style={{ color: "black" }}>x</span>
          </button>
          <Col xl="3">
            <Button className="btn btn-lg btn-primary" tag="button" onClick={()=>{saveFiche()}}>
              CREER LA FICHE
            </Button>
          </Col>
        </div>
        <div className="modal-body">
          <Row>
            <Col xl="12">
              <FormGroup className="mb-4">
                <div className="mb-3">
                  <Label>Livreur</Label>
                  <Select
                    value={selectLivreur}
                    onChange={handleLivreur}
                    options={optionLivreur}
                    classNamePrefix="select2-selection"
                  />
                </div>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xl="6">
              <strong style={{ fontSize: 16, color:"rgb(236, 83, 108)"}}>{msgError}</strong>
              <strong style={{ fontSize: 16, color: "#02a499" }}>{msgSuccess}</strong>
            </Col>
          </Row>
        </div>
      </Modal>
      <Row>
        <Col lg="4">
          <div className="mb-3">
            <Label>Agence</Label>
            <Select
              value={selectedDest}
              onChange={handleDestination}
              options={optionGroup}
              classNamePrefix="select2-selection"
            />
          </div>
        </Col>
        <Col lg="3">
          <div className="mt-3">
            <Button type="button" style={{ width: "100%" }} onClick={()=>{loadFiches(0)}} color="primary" data-toggle="Button" size="lg" className="mt-2 waves-effect waves-light">Rechargé</Button>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xl="4" className="mb-4">
          <Button className="btn btn-lg btn-primary" tag="button" data-toggle="modal" data-target=".bs-example-modal-lg" onClick={() => {setReadOnly(false); tog_formfiche()}}>
            CREER UNE FICHE DE LIVRAISON
          </Button>
        </Col>
      </Row>
     <Row>
        <Col>
          <Card>
            <CardBody>
              <CardTitle className="h4">{totalFiches} élément(s) </CardTitle>
              <Card>
                {totalPage ==0 ? ( null): totalPage>=25 ? (<nav aria-label="...">
                  <Pagination>
                      {Array.from({ length: 25}, (_, index) => (
                      <PaginationItem active={index==currPage} ><PaginationLink  onClick={()=>loadFiches(index)}>{index+1}</PaginationLink></PaginationItem>
                      ))}
                      <PaginationItem><PaginationLink onClick={()=>loadFiches(totalPage-1)}>......{totalPage-1}</PaginationLink></PaginationItem>
                      <PaginationItem><PaginationLink onClick={()=>loadFiches(currPage+1)}>Suivant</PaginationLink></PaginationItem>
                  </Pagination>
                </nav>): (<nav aria-label="...">
                  <Pagination>
                      {Array.from({ length: totalPage}, (_, index) => (
                      <PaginationItem active={index==currPage} ><PaginationLink  onClick={()=>loadFiches(index)}>{index+1}</PaginationLink></PaginationItem>
                      ))}
                      <PaginationItem><PaginationLink onClick={()=>loadFiches(currPage+1)}>Suivant</PaginationLink></PaginationItem>
                  </Pagination>
                </nav>)}
              </Card>

              <div className="table-rep-plugin">
                <div
                  className="table-responsive mb-0"
                  data-pattern="priority-columns"
                >
                  <div>
                    {loadingFiche ? (<BarLoader width={"100%"} height={6}/>): null}
                  </div>
                  <Table
                    id="tech-companies-1"
                    className="table table-striped table-bordered"
                  >
                    <Thead>
                      <Tr>
                        <Th>ID</Th>
                        <Th>Date de création</Th>
                        <Th data-priority="1">Nom et prénom du livreur</Th>
                        <Th data-priority="3">Contact</Th>
                        <Th data-priority="3">Nombre demandes</Th>
                        <Th data-priority="3">Détail</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {fiches.map((item, key)=>(
                      <Tr>
                        <Td>{item.id}</Td>
                        <Td>{moment(item.create).format("DD-MM-YY HH:mm:ss")}</Td>
                        <Th><strong>{item?.livreur?.nom}</strong> </Th>
                        <Td>{item?.livreur?.phone}</Td>
                        <Td>{item?.details?.length}</Td>
                        <Td><Button onClick={()=>{navigate('/view-fiche', {state: {fiche: item}});}} ><i className="fa fa-eye"></i></Button></Td>
                        {/* {item.bordLock==0 ? (<Td><Button onClick={()=>{lockBord(item.bordId); setTimeout(() => { tog_lock_bord() }, 200);}} className="btn-success"><i className="fa fa-lock-open"></i></Button></Td>): (<Td><Button onClick={()=>{lockBord(item.bordId); setTimeout(() => { tog_lock_bord() }, 200);}}  className="btn-danger"><i className="fa fa-lock"></i></Button></Td>)}
                        <Td>{item.bordStat.etatId==1 ? (<Button onClick={()=>{setBordSend(item.bordId); tog_send_bord()}} className="btn-primary">Envoyer</Button>): (<strong>{item.bordStat.etatLibelle}</strong>)}</Td> */}
                      </Tr>
                      ))}
                      
                    </Tbody>
                  </Table>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

    </React.Fragment>
  )
}
export default connect(null, { setBreadcrumbItems })(Fiches);